<div class="sigma_preloader" [ngClass]="windowLoad ? 'hidden':''">
    <img src="assets/img/christian.svg" alt="preloader">
</div>